var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56 10.7692C9.07842 10.7692 11.12 8.80617 11.12 6.38462C11.12 3.96306 9.07842 2 6.56 2C4.04158 2 2 3.96306 2 6.38462C2 8.80617 4.04158 10.7692 6.56 10.7692Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6035 6.61536H7.71619C6.945 6.61536 6.31982 7.21648 6.31982 7.95801V12.6573C6.31982 13.3988 6.945 14 7.71619 14H12.6035C13.3747 14 13.9998 13.3988 13.9998 12.6573V7.95801C13.9998 7.21648 13.3747 6.61536 12.6035 6.61536Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuShape);
export default __webpack_public_path__ + "static/media/a11ymenu_shape.cd82572930641e4be79486ca7fde51ed.svg";
export { ForwardRef as ReactComponent };